import { useContext } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomCard,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateClient } from "../../../../types/client.interface";
import "./index.scss";
import { ICreateAndUpdateCategory } from "../../../../types/category.interface";
import TitleLine from "../../../../components/TitleLine";
import TypeContainer from "./TypeContainer";

const Body = (data: any) => {
  const { resultCategory, setSelectedCategory, setShowModal } = useContext(
    Context.CategoryScreen
  );

  const categories = resultCategory?.data?.result?.docs;

  const onEdit = (category: ICreateAndUpdateCategory) => {
    setSelectedCategory!(category);
    setShowModal!("UPDATE");
  };
  const onRemove = (category: ICreateAndUpdateCategory) => {
    setSelectedCategory!(category);
    setShowModal!("DELETE");
  };

  const homeType = categories?.filter((item: any) => item?.type === "home");
  const constructionWaste = categories?.filter(
    (item: any) => item?.type === "construction_waste"
  );
  const wellEmptyingType = categories?.filter(
    (item: any) => item?.type === "well_emptying"
  );
  const secondHand = categories?.filter(
    (item: any) => item?.type === "second_hand"
  );
  const offices = categories?.filter((item: any) => item?.type === "offices");
  const hospitalWaste = categories?.filter(
    (item: any) => item?.type === "hospital_waste"
  );
  const industrial = categories?.filter(
    (item: any) => item?.type === "industrial"
  );

  if (categories?.length <= 0 || !data) return <TableNullData />;
  return (
    <>
      <TypeContainer
        items={homeType}
        title="خانگی"
        onEdit={onEdit}
        onRemove={onRemove}
      />
      <TypeContainer
        items={constructionWaste}
        title="نخاله ساختمانی"
        onEdit={onEdit}
        onRemove={onRemove}
      />
      <TypeContainer
        items={wellEmptyingType}
        title="تخلیه چاه"
        onEdit={onEdit}
        onRemove={onRemove}
      />
      <TypeContainer
        items={wellEmptyingType}
        title="تخلیه چاه"
        onEdit={onEdit}
        onRemove={onRemove}
      />
      <TypeContainer
        items={secondHand}
        title="دست دوم"
        onEdit={onEdit}
        onRemove={onRemove}
      />
      <TypeContainer
        items={offices}
        title="ادارات"
        onEdit={onEdit}
        onRemove={onRemove}
      />
      <TypeContainer
        items={hospitalWaste}
        title="بیمارستانی"
        onEdit={onEdit}
        onRemove={onRemove}
      />
      <TypeContainer
        items={industrial}
        title="صنعتی"
        onEdit={onEdit}
        onRemove={onRemove}
      />
    </>
  );
};

export default Body;
